import { render, staticRenderFns } from "./completeProfile.vue?vue&type=template&id=20446e2f&scoped=true&"
import script from "./completeProfile.vue?vue&type=script&lang=js&"
export * from "./completeProfile.vue?vue&type=script&lang=js&"
import style0 from "./completeProfile.vue?vue&type=style&index=0&id=20446e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20446e2f",
  null
  
)

export default component.exports